import React from 'react';
import { Eye, Copy, ExternalLink, Loader2 } from 'lucide-react';

const UrlPreviewPanel = ({ preview, onUrlChange, onCopy }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <div className="flex items-center gap-2 mb-4">
        <Eye className="h-5 w-5 text-primary" />
        <h2 className="text-lg font-semibold">Preview da URL</h2>
      </div>
      
      {/* URL de teste */}
      <div className="space-y-4">
        <div>
          <label htmlFor="preview_url" className="block text-sm font-medium mb-1">
            URL para teste
          </label>
          <input
            id="preview_url"
            type="text"
            value={preview.url}
            onChange={(e) => onUrlChange(e.target.value)}
            className="w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            placeholder="https://example.com/product?id=123"
          />
        </div>

        {/* Resultado */}
        <div>
          <div className="flex items-center justify-between mb-1">
            <label className="block text-sm font-medium">Resultado</label>
            {preview.result && (
              <button
                onClick={() => onCopy(preview.result)}
                className="inline-flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800"
              >
                <Copy className="h-3 w-3" />
                Copiar
              </button>
            )}
          </div>
          <div className="relative">
            <textarea
              value={preview.result}
              readOnly
              rows={4}
              className="w-full rounded-md border border-input px-3 py-2 text-sm bg-gray-50 font-mono"
              placeholder="O resultado da URL rastreada aparecerá aqui..."
            />
            {preview.isLoading && (
              <div className="absolute inset-0 bg-white/80 flex items-center justify-center rounded-md">
                <Loader2 className="h-5 w-5 animate-spin text-primary" />
              </div>
            )}
          </div>
          
          {/* Link para testar */}
          {preview.result && (
            <div className="mt-2">
              <a
                href={preview.result}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
              >
                <ExternalLink className="h-3 w-3" />
                Testar link
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UrlPreviewPanel;